import DuckEntity from './DuckEntity';

const authPaymentMethods = new DuckEntity('authPaymentMethods');

export default authPaymentMethods.reducer;
export { authPaymentMethods };
